module.exports = __webpack_public_path__ + "media/images/prepaid-2-83d912f585fd8c116e3dc74d51efedb8.png";